import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import { db } from "../config/firebase";

const countriesCollection = collection(db, "countries");

const countryService = {
  _cache: new Map(), // cache { countryId: countryName }
  getAll: async () => {
    try {
      const countriesSnapshot = await getDocs(countriesCollection);
      const countriesList = countriesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      return countriesList;
    } catch (error) {
      console.error("Error fetching countries:", error);
      throw error;
    }
  },
  add: async (countriesData) => {
    try {
      const docRef = await addDoc(countriesCollection, countriesData);
      return docRef;
    } catch (error) {
      console.error("Error adding countries:", error);
      throw error;
    }
  },
  edit: async ({ id, data }) => {
    try {
      const countryRef = doc(db, "countries", id);
      await updateDoc(countryRef, data);
    } catch (error) {
      console.error("Error updating countries:", error);
      throw error;
    }
  },
  delete: async (countryId) => {
    try {
      await deleteDoc(doc(db, "countries", countryId));
      return true;
    } catch (error) {
      console.error("Error deleting countries:", error);
      throw error;
    }
  },

  getNameById: async (countryId) => {
    if (!countryId) return null;
    try {
      const countryRef = doc(db, 'countries', countryId);
      const countrySnap = await getDoc(countryRef);

      if (countrySnap.exists()) {
        return countrySnap.data().name;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error getting country name:', error);
      throw error;
    }
  },

  getIdByName: async (countryName) => {
    try {
      const capitalizeWords = (str) =>
        str
          .toLowerCase()
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");

      const formattedName = capitalizeWords(countryName.trim());

      const countriesSnapshot = await getDocs(countriesCollection);
      const countryList = countriesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const country = countryList.find(
        (country) => country.name === formattedName
      );
      return country ? country.id : null;
    } catch (error) {
      console.error("Error getting country ID:", error);
      throw error;
    }
  },

  getByName: async (countryName) => {
    try {
      const capitalizeWords = (str) =>
        str
          .toLowerCase()
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");

      const formattedName = capitalizeWords(countryName.trim());

      const countriesSnapshot = await getDocs(countriesCollection);
      const countryList = countriesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const country = countryList.find(
        (country) => country.name === formattedName
      );
      return country || null;
    } catch (error) {
      console.error("Error getting country by name:", error);
      throw error;
    }
  },
};

export default countryService;
